import { authHeader } from '@/_helpers'
export const emailsService = {
  getAll,
  getThreadById,
  getById,
  associateOpportunity,
  associateBusinessContact,
  setValidStatus,
  replyEmail,
  sendTestEmail,
  createOpportunity,
  updateTemplate,
  getAllTemplates,
  getTemplate,
  getAgencyEmails,
  getNylasEmails,
  getNylasEmail,
  getNylasEmailsList,
  emailDone,
  getAntispamAuditList,
  checkAntispamAudit,
  getAntispamAuditBody,
  reTagEmail,
  getEmailResponseStatus,
  getAPIEmail,
  getLastEmails,
  disassociateOpportunityEmail,
  updateSmtpStatus,
  getByIdAllSource,
  getAiTag
}

const apiUrl = process.env.VUE_APP_ROOT_API

function getAll(
  currentPage,
  cantPerPage,
  searchFilter,
  filters,
  targetId,
  salesUserFilter,
  clientFilter,
) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter: filters }),
  }
  return fetch(
    `${apiUrl}/email-response/filtered-list?currentPage=${currentPage}&cantPerPage=${cantPerPage}&inputSearchFilter=${searchFilter}&targetId=${targetId}`,
    requestOptions,
  ).then(handleResponse)
}

function getAgencyEmails() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }

  return fetch(`${apiUrl}/clients/get-agency-list`, requestOptions).then(
    handleResponse,
  )
}

function getLastEmails(userid,filter) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({filter}),
  }

  return fetch(`${apiUrl}/email-response/getlastemails/${userid}`, requestOptions).then(
    handleResponse,
  )
}

function getAPIEmail(id,email) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({email}),
  }

  return fetch(`${apiUrl}/email-response/getapiemail/${id}`, requestOptions).then(
    handleResponse,
  )
}

function getEmailResponseStatus() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }

  return fetch(
    `${apiUrl}/email-response/get-email-response-status`,
    requestOptions,
  ).then(handleResponse)
}

function updateSmtpStatus(id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ id }),
  }

  return fetch(`${apiUrl}/clients/update-smtp-status`, requestOptions).then(
    handleResponse,
  )
}

function emailDone(email_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ email_id }),
  }

  return fetch(`${apiUrl}/clients/emaildone`, requestOptions).then(
    handleResponse,
  )
}

function getAntispamAuditList(filters = {}) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(filters),
  }

  return fetch(`${apiUrl}/clients/get-antispam-audit`, requestOptions).then(
    handleResponse,
  )
}


function getAntispamAuditBody(audit_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ audit_id }),
  }

  return fetch(`${apiUrl}/clients/get-antispam-audit-body`, requestOptions).then(
    handleResponse,
  )
}

function checkAntispamAudit(audit_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ audit_id }),
  }

  return fetch(`${apiUrl}/clients/check-antispam-audit`, requestOptions).then(
    handleResponse,
  )
}

function getNylasEmail(client_nylas_id, email_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_nylas_id, email_id }),
  }

  return fetch(`${apiUrl}/clients/get-email`, requestOptions).then(
    handleResponse,
  )
}

function getNylasEmails(emailkey, currentPage, cantPerPage) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ emailkey, currentPage, cantPerPage }),
  }

  return fetch(`${apiUrl}/clients/get-antispam`, requestOptions).then(
    handleResponse,
  )
}

function getNylasEmailsList(done) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ done }),
  }

  return fetch(`${apiUrl}/clients/get-antispam-list`, requestOptions).then(
    handleResponse,
  )
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/email-response/${id}`, requestOptions)
    .then(handleResponse)
    .then((message) => decodeMessage(message))
}

function getAiTag(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/email-response/ai-tag/${id}`, requestOptions)
    .then(handleResponse)
    .then((message) => decodeMessage(message))
}

function getByIdAllSource(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/email-response/get-all-source/${id}`, requestOptions)
    .then(handleResponse)
    .then((message) => decodeMessage(message))
}

function decodeMessage(message) {
  return message
}

function getThreadById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/email-response/${id}/thread`, requestOptions).then(
    handleResponse,
  )
}

function replyEmail(email, image) {
  let formData = new FormData()
  formData.append('image', image)
  formData.append('email', JSON.stringify(email))

  const requestOptions = {
    method: 'POST',
    headers: authHeader(null),
    body: formData,
  }

  // const requestOptions = {
  //     method: 'POST',
  //     headers: authHeader('application/json'),
  //     body: JSON.stringify(email)
  // };

  return fetch(`${apiUrl}/email-sent/`, requestOptions).then(handleResponse)
}

function sendTestEmail(campaign, testBusinessContactSelected) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      campaign: campaign,
      testBusinessContactSelected: testBusinessContactSelected,
    }),
  }

  return fetch(`${apiUrl}/email-sent/test`, requestOptions).then(handleResponse)
}

function associateOpportunity(id, oppotunity) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(oppotunity),
  }

  return fetch(
    `${apiUrl}/email-response/${id}/associateOpportunity`,
    requestOptions,
  ).then(handleResponse)
}

function associateBusinessContact(id, business_contact) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(business_contact),
  }

  return fetch(
    `${apiUrl}/email-response/${id}/associateBusinessContact`,
    requestOptions,
  ).then(handleResponse)
}

function setValidStatus(id, status_id, message) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      email_response_status_id: status_id,
      message: message,
    }),
  }

  return fetch(`${apiUrl}/email-response/${id}/status`, requestOptions).then(
    handleResponse,
  )
}

function createOpportunity(id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/email-response/${id}/create-opportunity`,
    requestOptions,
  ).then(handleResponse)
}

function updateTemplate(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      data,
    }),
  }
  return fetch(`${apiUrl}/email-template/`, requestOptions).then(handleResponse)
}

function getAllTemplates(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      data,
    }),
  }
  return fetch(`${apiUrl}/email-template/filtered-list?cache=true&time=86400&allusers=true`, requestOptions).then(
    handleResponse,
  )
}

function getTemplate(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/email-template/${id}`, requestOptions).then(
    handleResponse,
  )
}

function reTagEmail(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({data}),
  }
  return fetch(`${apiUrl}/email-response/tag`, requestOptions).then(
    handleResponse,
  )
}

function disassociateOpportunityEmail(
  id
) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      id
    }),
  }
  return fetch(`${apiUrl}/email-response/disassociateOpportunityEmail`, requestOptions).then(
    handleResponse,
  )
}
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = data || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
